import { useEffect } from 'react';

/** Calls `handler` when the Escape key is pressed. */
export function useEscapeKey(handler: () => void) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') handler();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handler]);
}
